import { createContext } from 'react';

export interface IAdditionalValidationError {
	validationErrorId: string;
	errorMessage: string;
}
export const ADDITIONAL_VALIDATION_ERROR_SEPARATOR = '&';

export interface IWithAdditionalValidationState {
	mainFormValidationFail: boolean;
	additionalValidationErrors: IAdditionalValidationError[];
}

export const withAdditionalValidationState: IWithAdditionalValidationState = {
	mainFormValidationFail: false,
	additionalValidationErrors: [],
};

export interface IWithAdditionalValidationContext extends IWithAdditionalValidationState {
	setMainFormValidationFail(failStatus: boolean): void;
	addAdditionalValidationError(validationError: IAdditionalValidationError): void;
	removeAdditionalValidationError(errorId: string): void;
	removeAllAdditionalValidationErrorsInBlock(blockId: string): void;
}

export const WithAdditionalValidationContext = createContext<IWithAdditionalValidationContext>({
	setMainFormValidationFail: () => undefined,
	addAdditionalValidationError: () => undefined,
	removeAdditionalValidationError: () => undefined,
	removeAllAdditionalValidationErrorsInBlock: () => undefined,
	...withAdditionalValidationState,
});
